import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { RegisterRefiningUpdated } from "routes/asset-register/plugins/asset-mapping/register-mapping-updated"
import { uniqueId } from "library/database/split-id.mjs"
import { globalRefiningStatus } from "routes/asset-register/plugins/asset-mapping/global-mapping-status"

export function useIsAnythingRefining() {
    const { register } = useBoundContext()
    RegisterRefiningUpdated(uniqueId(register?._id)).useRefresh()
    if (!register) return false
    const status = globalRefiningStatus[uniqueId(register._id)]
    if (!status) return false

    return !hasFinishedRefining(status)
}

function hasFinishedRefining({ message, lastBlockSize, remaining, total }) {
    return message === "FINISHED" || lastBlockSize < 0 || (total > 0 && remaining <= 0)
}
